import React, { useCallback, useRef, useEffect } from 'react';

import { DEFAULT_COLOR_FILTERS } from 'commons/constants';

import ColorsFilter from 'components/essentials/ColorsFilter';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';

const ProductListingColorFilter = ({
  colors = DEFAULT_COLOR_FILTERS,
  colorFilters,
  refineColorFilters,
  showAsTwoRows = false,
}) => {
  const { selectedColors, selectColor } = useAdvancedSearchContext();

  // Pending color to apply after Algolia finishes re-rendering
  const pendingColorRef = useRef(null);

  // After Algolia re-renders (colorFilters changes), apply the pending selectColor
  useEffect(() => {
    if (pendingColorRef.current !== null) {
      selectColor(pendingColorRef.current);
      pendingColorRef.current = null;
    }
  }, [colorFilters, selectColor]);

  const handleSelectColor = useCallback(
    colorLabel => {
      const matchedFilter = colorFilters.find(
        filter => filter.label.toLowerCase() === colorLabel.toLowerCase()
      );

      if (matchedFilter) {
        // Store the pending color, then trigger Algolia refinement first
        pendingColorRef.current = colorLabel;
        refineColorFilters(matchedFilter.label);
      }
    },
    [refineColorFilters, colorFilters]
  );

  if (!colors.length || !colors) {
    return null;
  }

  return (
    <ColorsFilter
      colors={colors}
      onSelectColor={handleSelectColor}
      selectedColors={selectedColors}
      showAsTwoRows={showAsTwoRows}
    />
  );
};

export default ProductListingColorFilter;
